module.exports = __webpack_public_path__ + "assets/img/TG.c5ff89b6.png";